export const memoType = {
  chapterTitle: "typo-doc-h1 text-foreground",
  sectionTitle: "typo-doc-h1 text-foreground",
  sectionIntent: "typo-body-md italic text-foreground",
  blockLabel: "typo-doc-h3 text-foreground",
  prose: "typo-body-md text-foreground [&_h3]:typo-doc-h3 [&_h4]:typo-doc-h3",
  html: "typo-body-md text-foreground [&_h1]:typo-doc-h1 [&_h2]:typo-doc-h2 [&_h3]:typo-doc-h3",
  quote: "typo-body-md",
  recordTitle: "typo-label-md text-foreground",
  recordValue: "typo-body-sm text-foreground",
  overline: "typo-overline text-muted-foreground",
  tableCell: "typo-body-sm",
  figure: "typo-h3 tabular-nums text-foreground",
  figureLabel: "typo-label-sm text-muted-foreground",
  chartLabel: "typo-label-sm text-muted-foreground",
  chartValue: "typo-label-sm tabular-nums text-foreground",
  columnValue: "typo-label-sm tabular-nums text-foreground",
  numbersToggle: "typo-label-md text-foreground",
  note: "typo-caption text-muted-foreground",
  number: "tabular-nums",
  axisTick: "typo-caption tabular-nums",
  cardName: "typo-label-sm text-foreground",
  cardValue: "typo-h5 tabular-nums text-foreground",
  cardQualifier: "typo-caption text-muted-foreground",
  cardKey: "typo-caption font-mono text-muted-foreground",
  cardOverline: "typo-overline text-muted-foreground",
  cardInputs: "typo-caption font-mono text-muted-foreground",
  cardGroup: "typo-caption text-muted-foreground"
};
